import React from "react";

/** Renders HTML strings from the CMS/API. */
export default function HtmlContent({ html, className = "", as: Tag = "div", ...props }) {
  if (!html?.trim()) return null;

  return (
    <Tag
      className={`font-sans leading-relaxed text-justify [&_p]:text-justify [&_b]:font-semibold [&_strong]:font-semibold [&_p]:mb-4 [&_p:last-child]:mb-0 [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:space-y-2 [&_li]:leading-relaxed [&_*]:font-inherit ${className}`}
      dangerouslySetInnerHTML={{ __html: html }}
      {...props}
    />
  );
}
